/** The authorities the signed-in person works for, and switching between them. */
import { useMutation, useQuery } from "@tanstack/react-query";

import { api, unwrap } from "@/api/client";

import { useSetSession } from "./session";

export const AUTHORITIES_KEY = ["my-authorities"] as const;

export function useMyAuthorities() {
  return useQuery({
    queryKey: AUTHORITIES_KEY,
    queryFn: async () => unwrap(await api.GET("/api/v1/auth/authorities")),
  });
}

export function useChooseAuthority() {
  const setSession = useSetSession();
  return useMutation({
    mutationFn: async (authorityId: string) =>
      unwrap(await api.POST("/api/v1/auth/authority", { body: { authorityId } })),
    onSuccess: setSession,
  });
}
